export default __webpack_public_path__ + "static/media/Raul Chamgerlain.59295f0e.jpg";